export function mapMonthValue(value: string) {
  return value.slice(0, -3)
}
